import { esXinyi } from './es.xinyi';
import { esXimen } from './es.ximen';
import { esCks } from './es.cks';
import { esHlcity } from './es.hlcity';
import { esTaroko } from './es.taroko';
import { esStory } from './es.story';
import { esAirport } from './es.airport';
import { esKaohsiung } from './es.kaohsiung';
import { esTainan } from './es.tainan';
import { esBarcelona } from './es.barcelona';
import { esGuide } from './es.guide';
import { esWorld3 } from './es.world3';
import { esTrips } from './es.trips';
import { esSky } from './es.sky';
import { esFamily } from './es.family';
import { esClassroom } from './es.classroom';
import { esLife } from './es.life';
import type { Messages } from './en';
import { esTalks3 } from './es.talks3';
import { esTreasure } from './es.treasure';
import { esPlaces } from './es.places';
import { esArcade } from './es.arcade';
import { esTalks } from './es.talks';
import { esExtra } from './es.extra';

export const es: Messages = {
  meta: {
    title: 'Aventura en el insti: ¡hoy no te desmayes!',
  },

  start: {
    title: 'Aventura en el insti',
    tagline: '¡Hoy no te desmayes!',
    blurb: 'Una semana en la vida de un alumno mediador de secundaria: clases, familia, amigos… y mucho té.',
    language: 'Idioma',
    look: 'Tu aspecto',
    pet: 'Una mascota que te acompañe',
    birthdays: 'Cumpleaños (pon los tuyos)',
    you: 'Tú',
    mom: 'Mamá',
    dad: 'Papá',
    emma: 'Emma',
    month: 'M',
    day: 'D',
    newGame: 'Nueva partida',
    continue: 'Continuar',
    continueInfo: (week: number, day: string, time: string) => `Semana ${week} · ${day} · ${time}`,
    confirmNew: '¿Empezar una nueva partida? Perderás el progreso guardado.',
    controls: 'Moverse: flechas / WASD / tocar · Interactuar: Espacio / E · Saltar: Espacio / X / 🦘 · Mapa: M · Misiones: Q · Menú: Esc',
  },

  looks: ['Pelo castaño corto', 'Pelo negro largo', 'Pelo rojo rizado', 'Coleta rubia'],

  pets: {
    rabbit: 'Conejito',
    cat: 'Gato',
    dog: 'Shiba',
    hedgehog: 'Erizo',
    hamster: 'Hámster',
    croc: 'Cocodrilo',
    fish: 'Pez',
    dino: 'Dino',
  },

  days: {
    fri: { name: 'Viernes', kind: 'Día de clase' },
    sat: { name: 'Sábado', kind: 'Fin de semana' },
    sun: { name: 'Domingo', kind: 'Día de la Madre' },
  },

  zones: {
    counsel: 'Sala de orientación',
    corridor: 'Aulas',
    yard: 'Patio',
    field: 'Campo de deportes',
    home: 'Casa',
    schoolGate: 'Recinto del insti',
    street: 'Calle Mayor',
    store: 'Tienda de la esquina',
    park: 'Parque',
    neighborhood: 'Barrio',
    classroom: 'Aula de 2.º C',
    library: 'Biblioteca',
    artRoom: 'Aula de arte y música',
    lobby: 'Vestíbulo',
    cafeteria: 'Comedor',
    restroom: 'Lavabos',
  },

  hud: {
    week: (n: number) => `Semana ${n}`,
    untilBed: (h: number, mm: string) => `${h}:${mm} hasta dormir`,
    energy: 'Energía',
    mood: 'Ánimo',
    study: 'Estudio',
    bladder: 'Pipí',
    stars: 'Estrellas',
    coins: 'Monedas',
  },

  tools: {
    english: 'Shadowing',
    radio: 'Radio',
    art: 'Arte',
    puzzle: 'Puzle',
    blocks: 'Bloques',
    social: 'PixelBook',
    party: 'Fiesta',
  },

  side: { todo: 'Hoy', bag: 'Mochila', shop: 'Tienda', phone: 'Móvil', menu: 'Menú', journal: 'Diario', quests: 'Misiones', map: 'Mapa' },

  common: {
    ok: 'Vale',
    close: 'Cerrar',
    back: 'Volver',
    gotIt: 'Entendido',
    cancel: 'Cancelar',
    yes: 'Sí',
    no: 'No',
    minutes: (n: number) => `${n} min`,
    alreadyToday: 'Eso ya lo has hecho hoy. ¡Prueba otra cosa!',
    me: 'Yo',
    thoughts: '(Pensando)',
    breathe: 'Respira hondo. ¡Que hoy sea un buen día!',
    looking: (label: string) => `Echas un vistazo: ${label}.`,
    stars: (n: number) => `${n > 0 ? '+' : ''}${n}⭐`,
    coins: (n: number) => `${n > 0 ? '+' : ''}${n}🪙`,
    closedToday: 'Hoy no hay nadie: el insti cierra los fines de semana.',
    schoolClosed: 'El insti está cerrado el fin de semana.',
  },

  objectives: {
    title: 'Objetivos de hoy',
    allDone: '¡Todos los objetivos cumplidos! Disfruta del resto del día.',
    bonus: (stars: number) => `¡Has cumplido todos los objetivos de hoy! Premio +${stars}⭐`,
    fri: {
      xiaoyu: 'Consolar a Xiaoyu en la sala de orientación',
      teacher: 'Contarle a la profesora Lin cómo está Xiaoyu',
      log: 'Escribir el diario de mediación en el escritorio',
      homework: 'Hacer los deberes en casa',
    },
    sat: {
      cookies: 'Hornear galletas de arándanos en casa',
      picnic: 'Hacer un pícnic con Emma en el patio',
      dishes: 'Fregar los platos',
      sister: 'Leerle un cuento a tu hermanita',
    },
    sun: {
      strawberries: 'Comprar fresas en la tienda',
      cake: 'Hornear un bizcocho chiffon de fresa',
      giveCake: 'Darle el pastel a Mamá',
      callDad: 'Llamar a Papá para que venga a cenar',
    },
  },

  chores: {
    title: 'Rutina de casa',
    hint: 'Ayuda en casa… ¡Mamá se fija en todo!',
    shoes: 'Zapatos y mochila en su sitio',
    dishes: 'Platos fregados',
    sister: 'Cuento con tu hermanita',
    homework: 'Deberes y shadowing hechos',
    shower: 'Ducha calentita y pijama limpio',
    callDad: 'Has llamado a Papá para que venga a cenar',
    allTitle: '🌟 Peque ejemplar del día 🌟',
    allText: '¡Has completado toda la rutina de casa! Mamá te da un abrazo enorme y algo de paga.',
    allClaim: '¡Gracias, Mamá! (+20⭐ +50🪙)',
  },

  status: {
    tired: 'Estás agotado/a… busca algo de beber o un sitio para descansar.',
    bladderWarn: '¡Necesitas ir al baño ya!',
    accident: 'Oh, no… no has llegado al baño a tiempo. Qué vergüenza.',
    collapseTitle: '¡Te has desmayado!',
    collapseText: 'Todo se vuelve negro… Te despiertas en el sofá dos horas después. ¡Acuérdate de beber y descansar!',
    xiaoyuComing: 'Xiaoyu va hacia la sala de orientación…',
    xiaoyuSits: 'Xiaoyu saca una silla y se sienta.',
    familyTime: '¡Ratito en familia! +ánimo',
    lateNight: 'Se está haciendo tarde. Vete a la cama en casa para terminar el día.',
  },

  summary: {
    title: (day: string) => `Fin del ${day.toLowerCase()}`,
    starsToday: 'Estrellas ganadas',
    goals: 'Objetivos cumplidos',
    chores: 'Rutina de casa',
    collapses: 'Veces que te has desmayado',
    mood: 'Ánimo final',
    momLove: 'Cariño de Mamá',
    next: 'Dormir y empezar el día siguiente',
    weekTitle: (week: number) => `¡Semana ${week} completada!`,
    weekText: (stars: number, rank: string) => `Estrellas totales: ${stars}. Rango: ${rank}.`,
    ranks: ['Vas por buen camino', 'Buena gente', 'Estrella mediadora', 'Leyenda del insti'],
    nextWeek: 'Empezar la semana siguiente',
  },

  sleep: {
    label: 'Cama',
    title: 'Tu camita',
    early: 'Es muy pronto para dormir. ¿Una siestecita?',
    nap: 'Siesta de 30 minutos (+energía)',
    sleep: 'Dormir (terminar el día)',
    stay: 'Todavía no',
  },

  menu: {
    title: 'Menú',
    resume: 'Seguir',
    language: 'Idioma',
    sound: (on: boolean) => `Sonido: ${on ? 'sí' : 'no'}`,
    voice: (on: boolean) => `Voces: ${on ? 'sí' : 'no'}`,
    endDay: 'Terminar el día ya',
    endDayConfirm: '¿Saltar al final del día?',
    newGame: 'Nueva partida',
    save: 'Guardar partida',
    saved: 'Partida guardada.',
  },

  bag: {
    title: '🎒 Mi mochila',
    use: 'Usar',
    empty: 'Tu mochila está vacía.',
    items: {
      tea: { name: 'Bolsita de té', desc: 'Beber: +12 de energía' },
      orange: { name: 'Mandarina', desc: 'Comer: +10 de energía' },
      candy: { name: 'Caramelo de frutas para la garganta', desc: 'Comer: +4 de ánimo. Un buen regalo.' },
      cookies: { name: 'Galletas de arándanos', desc: 'Comer: +8 de energía, +6 de ánimo. Geniales para compartir.' },
      cake: { name: 'Bizcocho chiffon de fresa', desc: 'Un regalo de corazón.' },
      strawberries: { name: 'Fresas', desc: 'Para hornear un pastel.' },
      book: { name: 'Libro ilustrado', desc: 'Para la hora del cuento.' },
      water: { name: 'Botella de agua', desc: 'Beber: +6 de energía (rellénala en la fuente)' },
      riceBall: { name: 'Bola de arroz', desc: 'Comer: +15 de energía' },
      juice: { name: 'Zumo en brik', desc: 'Beber: +10 de energía' },
      atlas: { name: 'Atlas del mundo', desc: 'El atlas que le falta a la biblioteca.' },
      kite: { name: 'Cometa', desc: 'La cometa roja de Bo.' },
      kitten: { name: 'Mochi, la gatita', desc: 'La gatita de la abuela Lee. ¡Te va siguiendo!' },
      letter: { name: 'Carta', desc: 'La carta de Mamá para la abuela Lee.' },
    },
    used: (name: string) => `Has usado: ${name}`,
    emptyBottle: 'La botella está vacía: rellénala en la fuente de agua.',
  },

  shop: {
    title: '🛒 Cooperativa del insti',
    hint: 'Paga con monedas. Las ganas ayudando en casa y resolviendo puzles.',
    buy: 'Comprar',
    bought: (name: string) => `Has comprado: ${name}`,
    poor: '¡No tienes suficientes monedas!',
  },

  objects: {
    desk: 'Mesa de mediación',
    tea: 'Rincón del té y el cacao',
    water: 'Fuente de agua',
    shelf: 'Estantería',
    plant: 'Planta en maceta',
    sofa: 'Sofá',
    toilet: 'Lavabo',
    easel: 'Caballete',
    chineseDesk: 'Mesa de escritura',
    piano: 'Piano de cola',
    board: 'Tablón de anuncios',
    field: 'Jardín exterior',
    bench: 'Banco',
    shoes: 'Zapatero',
    sink: 'Fregadero',
    oven: 'Horno',
    homeDesk: 'Escritorio',
    bath: 'Baño',
    bed: 'Cama',
    picnic: 'Manta de pícnic',
    atlasDesk: 'Pupitre',
    libShelf: 'Estantería de la biblioteca',
    vending: 'Máquina expendedora',
    canteen: 'Barra del comedor',
    busStop: 'Parada de autobús',
    mailbox: 'Buzón',
    pond: 'Estanque',
    bush: 'Arbusto',
    kiteTree: 'Árbol grande',
    swing: 'Columpio',
    fridge: 'Nevera',
    tv: 'Tele',
    shopCounter: 'Mostrador',
  },

  npc: {
    chunbo: 'El tío Chun',
    emma: 'Emma',
    teacher: 'La profesora Lin',
    xiaoyu: 'Xiaoyu',
    mom: 'Mamá',
    sister: 'Hermanita',
    dad: 'Papá',
    librarian: 'La señora Wang',
    rain: 'Rain',
    coach: 'El entrenador Hsu',
    clerk: 'Kai',
    grandma: 'La abuela Lee',
    bo: 'Bo',
    cat: 'Gato',
  },

  desk: {
    text: 'La pantalla muestra el horario de mediación y las notas de hoy.',
    log: 'Escribir el diario de mediación',
    logDone: 'Diario guardado: «Xiaoyu (2.º de ESO) suele parecer cansado por problemas en casa. Paciencia y amabilidad».',
    english: 'Abrir la práctica de shadowing',
    schedule: 'Ver los objetivos de hoy',
  },

  tea: {
    text: 'La tetera humea suavemente. Huele a cebada tostada y a cacao.',
    drink: 'Prepararte un cacao caliente (+18 de energía)',
    drinkToast: 'Calentito y dulce: ¡estás despierto/a del todo!',
    share: 'Preparar una tetera para compartir (+3 bolsitas de té)',
    shareToast: 'Guardas 3 bolsitas de té para regalar.',
    watch: 'Mirar cómo gotea (+6 de ánimo)',
    watchToast: 'Plic… plic… qué relajante.',
  },

  water: {
    text: 'Una fuente azul y transparente con grifo de agua fría y caliente.',
    cold: 'Agua fría (+6 de energía)',
    coldToast: 'Glu, glu… ¡qué fresquita!',
    hot: 'Té caliente (+8 de ánimo)',
    hotToast: 'Una taza de té calentito te reconforta.',
    refill: 'Rellenar la botella',
    refillToast: '¡Botella llena!',
  },

  shelf: {
    text: 'Filas de libros de colores: rojos, azules, verdes y dorados.',
    read: 'Leer «La psicología de la autodisciplina» (+8 de estudio)',
    readToast: '¡La disciplina no es una jaula: es el volante de tu propia vida!',
    borrow: 'Coger prestado un libro ilustrado para tu hermanita',
    borrowToast: '¡Tienes un libro ilustrado!',
    english: 'Abrir la práctica de shadowing',
  },

  plant: {
    text: 'Hojas de tres tonos de verde en una maceta de barro.',
    water: 'Pulverizar las hojas (+6 de ánimo)',
    waterToast: 'Las gotitas brillan sobre las hojas.',
    prune: 'Quitar las hojas viejas y remover la tierra',
    pruneToast: '¡La planta se ve sana y feliz!',
  },

  sofa: {
    text: 'Un sofá beis blandito, perfecto para un descanso.',
    nap: 'Cerrar los ojos 20 minutos (+energía, +ánimo)',
    napToast: 'Te sientes en calma y con las pilas cargadas.',
  },

  toilet: {
    notNeeded: 'Ahora mismo no necesitas ir al baño.',
    done: '¡Ahhh, mucho mejor!',
  },

  art: {
    title: 'Aula de arte · Caballete',
    text: 'En el caballete pone **los seis pilares del buen gusto visual**:\n1. **Forma**: contorno y proporción\n2. **Color**: armonía, cálidos y fríos\n3. **Textura**: vetas de madera, tela, tacto\n4. **Composición**: equilibrio, espacio en blanco, ritmo\n5. **Estructura**: orden y soporte\n6. **Práctica diaria**: observar → recopilar → imitar → crear',
    quiz: '🎨 Test de mezcla de colores',
    quizQ: 'Si mezclas azul cobalto y amarillo limón a partes iguales, ¿qué obtienes?',
    quizA: ['Verde hierba fresca', 'Violeta oscuro', 'Mandarina intenso'],
    quizRight: '¡Correcto! Azul + amarillo = verde.',
    quizWrong: ['Eso es azul + rojo. ¡Inténtalo otra vez!', '¡Eso es rojo + amarillo!'],
    steps: '🖼️ La práctica en cuatro pasos',
    stepsText: '① **Observar**: fíjate en el equilibrio, el contraste y la armonía\n② **Recopilar**: haz fotos de colores y composiciones que te gusten\n③ **Imitar**: prueba esas paletas en tu cuarto o en tu ropa\n④ **Crear**: ¡desarrolla tu propio estilo!',
    stepsClaim: '¡Entendido! (+5⭐)',
  },

  writing: {
    title: 'Mesa de escritura',
    text: 'En la pizarra hay estructuras de frases para enlazar ideas.',
    a: '✍️ Frases con «Aunque…, …»',
    aQ: 'Elige la frase que tiene sentido:',
    aGood: 'Aunque llovía a cántaros, llegamos al insti a tiempo y con mucha energía.',
    aBad: 'Aunque desayuné, tenía la barriga llena.',
    aRight: '¡Fluida y lógica!',
    aWrong: 'El contraste del «aunque» no acaba de funcionar ahí. ¡Piénsalo otra vez!',
    b: '✍️ Frases con «No solo…, sino también…»',
    bQ: 'Elige la mejor frase:',
    bGood: '¡Xiaoyu no solo habló de lo que le preocupaba, sino que también leyó un texto en inglés en voz alta!',
    bBad: 'Xiaoyu no solo estaba cansado, sino que también el cielo es azul.',
    bRight: '¡Una frase genial!',
    bWrong: 'Las dos mitades no se complementan.',
  },

  piano: {
    title: 'Aula de música · Piano de cola',
    text: 'Las teclas brillan en negro y marfil bajo el sol.',
    free: '🎹 Tocar libremente',
    freeText: 'Toca una tecla para que suene:',
    played: (note: string) => `♪ ${note}`,
    finish: 'Terminar la práctica (+3⭐)',
    ear: '👂 Prueba de oído',
    earQ: '¿Qué nota acabas de oír?',
    replay: '🔁 Volver a tocarla',
    note: (n: string) => `Nota ${n}`,
    right: '¡Oído absoluto!',
    wrong: (n: string) => `Era ${n}. ¡Sigue practicando!`,
  },

  catchBall: {
    title: 'Bola alta en el jardín',
    text: (wind: string) => `¡Una bola alta cruza el cielo! El viento sopla ${wind}.`,
    winds: { left: 'hacia la izquierda', right: 'hacia la derecha', none: 'muy flojito' },
    left: 'Correr a la izquierda',
    right: 'Correr a la derecha',
    stay: 'Quedarse quieto y esperar',
    caught: '¡Gran atrapada! ¡El público te aclama!',
    missed: 'La bola cae justo fuera de tu alcance. ¡Por poco!',
  },

  board: {
    title: 'Tablón de anuncios',
    text: 'Notas clavadas: «Los alumnos mediadores se reúnen en la sala de orientación. Sé amable, ve con cuidado y pide ayuda».',
  },

  bench: {
    text: 'Un banco de madera bajo los árboles.',
    rest: 'Sentarte a escuchar a los pájaros (+ánimo)',
    restToast: 'La brisa mece las hojas. Qué paz.',
  },

  oven: {
    title: 'Cocina · Horno',
    text: 'El horno brilla con un naranja cálido. La harina y la mantequilla esperan en la encimera.',
    cookies: '🍪 Hornear galletas de arándanos',
    cookiesWork: 'Mezclando, formando bolitas, horneando…',
    cookiesDone: '¡Ding! ¡Ya están listas 3 galletas de arándanos!',
    cake: '🍰 Hornear un bizcocho chiffon de fresa',
    cakeNeeds: 'Primero necesitas fresas: cómpralas en la cooperativa.',
    cakeWork: 'Montando el merengue, horneando, decorando…',
    cakeDone: '¡Qué bien huele! ¡Un bizcocho chiffon de fresa!',
  },

  mom: {
    lines: [
      'Mamá te despeina con cariño. «¿Cansado/a? ¿Qué tal hoy en el insti?»',
      'Mamá sonríe. «Hoy el recibidor está muy ordenado. ¡Te estás haciendo mayor!»',
      'Mamá está doblando la ropa. «¿Te apetece algo especial para cenar?»',
    ],
    giveCake: '🎁 Darle a Mamá el pastel de fresa',
    giveCakeNone: 'Aún no tienes pastel en la mochila. ¡Hornea uno!',
    giveCakeReply: '¿De verdad lo has hecho para mí? Está buenísimo… ¡Qué feliz y qué emocionada estoy!',
    giveCookies: '🎁 Darle a Mamá unas galletas',
    giveCookiesNone: 'No tienes galletas en la mochila. ¡Hornea algunas primero!',
    giveCookiesReply: '¡Qué crujientes! Gracias, cariño.',
    hug: 'Abrazar a Mamá: «Gracias por todo. ¡Te quiero!»',
    hugReply: 'Verte sano/a, feliz y responsable es todo lo que necesito.',
    tired: 'Mamá sonríe. «Hoy ya nos hemos dado el abrazo. Ve a descansar, cariño».',
    helpOpt: '¿Necesitas ayuda, Mamá?',
    letter: '¿Puedes llevarle esta carta a la abuela Lee? Suele estar en el parque, cerca del estanque.',
  },

  shoes: {
    text: 'Por fin en casa. Hora de quitarse los zapatos y dejar la mochila.',
    act: 'Colocar los zapatos y colgar la mochila',
    done: 'Todo en su sitio. ¡Mamá se ha dado cuenta!',
  },

  sink: {
    text: 'Las fiambreras y los platos de la cena esperan en el fregadero.',
    act: 'Fregar los platos y las fiambreras',
    done: '¡Relucientes! Mamá dice que eres un encanto.',
  },

  sister: {
    text: 'Tu hermanita viene corriendo con sus juguetes. «¡Ya estás en casa!»',
    read: 'Leerle un libro ilustrado',
    readNoBook: 'No tienes ningún libro ilustrado. Coge uno prestado de la estantería de la sala de orientación.',
    readDone: 'Se ríe durante todo el cuento. Mamá sonríe desde la puerta.',
    puzzle: 'Hacer juntos un puzle deslizante',
  },

  homeDesk: {
    text: 'Un escritorio ordenado y una lámpara de luz suave.',
    act: 'Hacer los deberes y luego un poco de shadowing',
    done: '¡Deberes hechos! Mamá está orgullosa de ti.',
  },

  bath: {
    text: 'Sale vapor de la bañera calentita.',
    shower: 'Ducharte y ponerte el pijama limpio',
    showerDone: '¡Fresquito, limpio y a gusto!',
    toilet: 'Ir al váter',
  },

  dad: {
    hello: 'Papá se afloja la corbata. «¡He llegado a tiempo para cenar, como te prometí!»',
    hug: 'Darle un abrazo a Papá',
    hugReply: 'Esta es la mejor bienvenida.',
  },

  xiaoyu: {
    title: 'Xiaoyu · 2.º de ESO',
    open: '…Hoy no tengo ninguna gana de ir a clase.',
    sitDown: 'Siéntate un ratito conmigo. ¿Quieres un cacao caliente?',
    tired: '…Mis padres volvieron a discutir hasta tarde. Estoy muy cansado. Y tengo miedo.',
    safe: 'Aquí estás a salvo. Quédate todo lo que necesites, yo me quedo contigo.',
    english: '¿Quieres que leamos algo en inglés juntos para despejarte?',
    better: '…Gracias. Me siento un poco mejor. Intentaré volver para la segunda hora.',
    promise: 'Nos vemos otra vez después de comer, ¿vale?',
    done: 'Ahora Xiaoyu confía en ti.',
    candy: 'Ofrecerle un caramelo para la garganta',
    candyNone: 'No tienes caramelos para la garganta.',
    candyDone: 'Xiaoyu coge el caramelo y asiente.',
    later: 'Xiaoyu te saluda con la mano de camino a clase.',
    satHello: '…Ah, hola. Hoy no quería quedarme en casa. Solo estoy aquí sentado.',
    satInvite: 'Emma y yo vamos a hacer un pícnic. ¿Te vienes?',
    satAccept: '¿En serio? Solo si a Emma le parece bien…',
    satJoined: 'Hacía mucho tiempo que no me lo pasaba tan bien un fin de semana. Gracias.',
    askEmma: '¿Puede venir Xiaoyu a nuestro pícnic?',
    emmaYes: '¡Pues claro! Cuantos más, mejor. ¡Le guardo un bocadillo!',
  },

  teacher: {
    before: '¿Has visto a Xiaoyu? Esta mañana no ha venido a clase. Estoy preocupada.',
    report: 'Decirle que Xiaoyu ya está tranquilo y que volverá para la segunda hora',
    thanks: 'Muchísimas gracias. Tener alumnos mediadores como tú marca la diferencia.',
    after: 'Gracias otra vez por cuidar hoy de Xiaoyu.',
  },

  chunbo: {
    title: 'El tío Chun · Conserje',
    versions: [
      {
        intro: '¡Buenos días, chaval! Todo tranquilo en mi ronda. ¡Luego pásate a tomar un té!',
        give: '¡Buenos días, tío Chun! Tome algo calentito',
        learn: 'Pedirle consejos de seguridad por el insti',
      },
      {
        intro: 'Antes había un desconocido repartiendo folletos en la puerta. Le he dicho que se fuera. ¡Id con cuidado!',
        give: '¡Gracias por cuidarnos! Tome, un detallito',
        learn: 'Preguntarle qué hacer con los desconocidos',
      },
      {
        intro: '¡Qué día tan bonito! Veros tan llenos de energía me hace sentir joven otra vez.',
        give: '¡Hoy está estupendo! Tome, un regalito',
        learn: 'Charlar sobre las flores del patio',
      },
    ],
    gotTea: '¡El tío Chun da un sorbo al té y sonríe de oreja a oreja!',
    gotCandy: 'El tío Chun se mete el caramelo en la boca. «¡Ah, qué bien me sienta en la garganta!»',
    gotNothing: 'Saludas al tío Chun con alegría.',
    hungryOpt: 'Parece cansado, tío Chun. ¿Va todo bien?',
    hungry: '¡Jaja, te has dado cuenta! Me he saltado el desayuno y no puedo dejar la puerta. Me ruge la tripa…',
    riceAccept: '¡Le traigo una bola de arroz de la tienda!',
    riceGive: 'Darle la bola de arroz al tío Chun 🍙',
    riceThanks: '¡Ah, todavía está calentita! Me has salvado. ¡Pásate por la garita cuando quieras!',
    tipTitle: 'El consejo del tío Chun',
    tip: 'No te pongas a hablar con desconocidos que se te acerquen y nunca aceptes comida ni bebida de gente que no conoces. ¡La seguridad, lo primero!',
    remember: '¡Me acordaré!',
  },

  emma: {
    lines: [
      '¡Ey! ¿Practicamos juntos la pronunciación en inglés?',
      '¡Hola! ¿Has escuchado hoy la radio en inglés? ¡La música era genial!',
      '¡Buenos días! ¿Has terminado los deberes? ¡Podemos estudiar juntos!',
    ],
    picnicLine: '¡Has venido! He traído una manta y zumo. ¿Tú has traído algo para compartir?',
    english: '¡Claro! Hagamos shadowing',
    radio: 'Escuchemos la radio',
    cookies: 'Darle unas galletas',
    cookiesNone: 'No tienes galletas en la mochila. ¡Hornea algunas en casa primero!',
    cookiesReply: '¡Hala, galletas caseras! ¡Huelen de maravilla! ¡Gracias!',
    picnicShare: 'Compartir tus galletas caseras',
    picnicNone: 'Todavía no tienes nada para compartir… ¡hornea galletas en casa primero!',
    picnicTitle: '🧺 Pícnic de fin de semana',
    picnicDone: 'Emma y tú compartís galletas sobre la hierba mientras suena música. ¡Una tarde perfecta!',
    absent: 'Emma no está por aquí ahora mismo.',
  },

  calls: {
    incoming: 'Llamada entrante',
    answer: 'Contestar',
    decline: 'Rechazar',
    declined: 'Llamada rechazada.',
    pool: {
      scamStock: {
        caller: 'Desconocido · «Asesores de Inversión»',
        desc: '0982-xxx-xxx (llamada comercial)',
        intro: '¡Hola! Somos una empresa de inversión líder. ¡Un 30 % de beneficio cada semana, garantizado! ¡Agréganos al chat ya y te damos consejos de bolsa gratis!',
        good: 'Colgar y denunciarlo a la línea antifraude 165',
        goodMsg: '¡Muy espabilado/a! Es una estafa de inversión de manual.',
        bad: '«¿De verdad? ¿Sin ningún riesgo?»',
        badMsg: '¡Cuidado! Prometer beneficios enormes es una señal de alarma: casi les das tu cuenta.',
      },
      scamGame: {
        caller: 'Sospechoso · «Soporte del juego»',
        desc: 'Dice que has ganado una skin legendaria gratis',
        intro: '¡Enhorabuena, jugador! ¡Has ganado una skin legendaria limitada! ¡Solo tienes que decirnos tu contraseña y el código SMS para que te la añadamos!',
        good: 'Negarte y colgar',
        goodMsg: '¡Exacto! El personal de verdad nunca pide contraseñas ni códigos.',
        bad: 'Leerles el código SMS',
        badMsg: '¡Oh, no! Te han robado la cuenta justo después de darles el código.',
      },
      insurance: {
        caller: 'Comercial · «Seguros Vida Segura»',
        desc: 'Vende un plan de ahorro',
        intro: '¡Hola! ¿Tienes dos minutos? Nuestro nuevo seguro de ahorro da muy buenos rendimientos, ¡y te llevas un regalo!',
        good: '«Gracias, pero soy menor de edad. Lo hablaré con mis padres».',
        goodMsg: '¡Educado y sensato! Las decisiones de dinero son cosa de toda la familia.',
        bad: 'Gritarles y colgar',
        badMsg: 'Un poco impulsivo… tu ánimo baja.',
      },
      mom: {
        caller: 'Mamá ❤️',
        desc: 'Solo quiere saber cómo estás',
        intro: 'Cariño, ha refrescado… ¿te has llevado la chaqueta? ¿Has comido bien?',
        good: '«¡Sí, Mamá! Voy abrigado/a y he comido mucho. ¡Cuídate tú también!»',
        goodMsg: 'A Mamá se le derrite el corazón. Sientes el calor de casa.',
        bad: '«Sí, sí, estoy liado/a, adiós».',
        badMsg: 'Mamá suspira bajito al otro lado…',
      },
      friend: {
        caller: 'Jay, tu mejor amigo 🏀',
        desc: 'Llama por lo de después de clase',
        intro: '¡Ey! ¡El gimnasio está libre después de clase! ¿Practicamos triples? ¡Tengo balón nuevo!',
        good: '«¡Vale! ¡Nos vemos en la pista!»',
        goodMsg: '¡Amigos para siempre! ¡Estás a tope!',
        bad: '«Primero acabo mis tareas de mediación. ¿Mañana?»',
        badMsg: '¡Decisión responsable! Jay dice que mañana le va bien.',
      },
    },
  },

  phone: {
    tabs: { chats: '💬 Chats', calls: '📞 Llamadas', feed: '🌐 Muro', radio: '📻 Radio' },
    chatsTitle: 'Chats',
    placeholder: 'Escribe un mensaje…',
    now: 'ahora',
    yesterday: 'Ayer',
    send: 'Enviar',
    stickers: 'Stickers',
    defaultReply: '¡Mensaje recibido! ¡Que tengas un día genial!',
    chats: {
      family: {
        name: 'Familia (4)',
        preview: 'Papá ha enviado una tarjeta de buenos días',
        msgs: [
          { from: 'Papá', text: '@card' },
          { from: 'Mamá', text: 'Id con cuidado todos. ¡Que tengáis un buen día!' },
          { from: 'Hermanita', text: '¡Buenos días! ¿Jugamos cuando vuelvas a casa?' },
        ],
        choices: [
          'Responder: ¡Buenos días! Llegaré a tiempo para cenar.',
          'Enviar una tarjeta de buenos días 🌸',
          'Responder a la hermanita: ¡Espérame, que te leo un cuento y hacemos un puzle!',
        ],
        r1: [
          { from: 'Mamá', text: '¡Qué bien! Te haré tu plato favorito.' },
          { from: 'Papá', text: '¡Yo también llegaré a tiempo!' },
        ],
        r1more: '¡Bien, qué ganas de cenar!',
        cardReply: { from: 'Papá', text: '¡Jaja, qué tarjeta tan bonita! ¡Que tengas un día lleno de energía!' },
        r3: [
          { from: 'Hermanita', text: '¡Bieeen! ¡Eres lo más! 🎉' },
          { from: 'Mamá', text: 'Qué monos sois los dos.' },
        ],
        replies: ['¡Entendido! ¡Cuidaos mucho todos!', '¡Que tengáis un día feliz!'],
      },
      friends: {
        name: 'Mejores amigos (3)',
        preview: 'Jay: ¿pícnic o baloncesto este finde?',
        msgs: [
          { from: 'Jay', text: 'Bueno, ¿pícnic o baloncesto este finde? 🏀' },
          { from: 'Rain', text: '¡Pícnic! ¿Quién trae la merienda? 🍰' },
          { from: 'Ming', text: '¡No os olvidéis de ver cómo está Xiaoyu, el de 2.º C!' },
        ],
        choices: [
          'A Rain: ¡Haré galletas de arándanos para el pícnic!',
          'A Ming: Xiaoyu está tranquilo en la sala de orientación, no te preocupes.',
          'A Jay: ¡Primero pícnic y luego un 3 contra 3!',
        ],
        r1: [
          { from: 'Rain', text: '¡Síííí! ¡Eres un genio de la repostería! 🍰' },
          { from: 'Jay', text: 'Primero comer y luego pelota. ¡Plan perfecto!' },
        ],
        r2: { from: 'Ming', text: '¡Gracias! Qué bien que estés ahí.' },
        r3: { from: 'Jay', text: '¡Hecho! El mejor finde de la historia.' },
      },
      mom: {
        name: 'Mamá ❤️',
        preview: 'Acuérdate de beber agua y desayunar',
        msgs: [
          { from: '', text: 'Hace frío: ponte la chaqueta y come bien a mediodía.' },
          { from: '', text: 'Si vas a llegar tarde, mándame un mensaje.' },
        ],
        choices: ['Responder: Vale, Mamá ❤️ ¡Comeré bien y volveré a la hora!', 'Enviar una tarjeta de buenos días 🌸'],
        r1: '¡Así me gusta! Ve con cuidado por el camino.',
        replyMorning: '¡Buenos días! Bebe un poco de agua tibia y desayuna.',
        replyLove: '¡Yo también te quiero! Vuelve pronto esta noche ❤️',
        replyOther: 'Vale, entendido. ¡Cuídate en el insti!',
        kwMorning: ['días', 'dias', 'desayun', 'comer', 'comida'],
        kwLove: ['te quiero', 'te amo', 'os quiero', '❤'],
      },
      emma: {
        name: 'Emma',
        preview: '¿Practicamos shadowing?',
        msgs: [{ from: '', text: '¡Ey! ¿Lista/o para practicar shadowing?' }],
        choices: ['¡Sí! Practiquemos ahora mismo.', '¿Me das una palabra difícil?'],
        r1me: '¡Sí! ¡Abro ahora la libreta de shadowing!',
        r1: '¡Genial! ¡A por la perfección! 💪',
        r2me: '¿Me das una palabra difícil para practicar?',
        r2: '¡Prueba con «responsibility» y «resilient»! 🌟',
        replies: ['¡Entendido! ¡Sigamos aprendiendo!', '¡Genial! ¡La práctica hace al maestro!'],
      },
    },
    card: [
      { top: '🌸😊🌸', big: 'Buenos días', sub: 'Empieza el día con una sonrisa\nTe deseo salud y suerte' },
      { top: '☀️🌻✨', big: 'Paz y alegría', sub: 'Que todo te salga bien\n¡Hoy, a tope de energía!' },
    ],
    stickerLines: ['🌸 ¡Que tengas un día precioso!', '☀️ ¡Un rayito de sol para ti!', '🌈 ¡Buen rollo!', '❤️ Os quiero', '💪 ¡Podemos con todo!', '👍 ¡Me parece bien!', '😂 ¡Jajaja!', '🙏 ¡Gracias!'],
    callList: {
      title: '📞 Contactos',
      mom: { name: 'Mamá', sub: 'Llamada familiar' },
      dad: { name: 'Papá', sub: 'Pedirle que venga a cenar' },
      friend: { name: 'Jay, tu mejor amigo', sub: 'Planes para el finde' },
      hotline: { name: 'Línea antifraude 165', sub: 'Comprobar si algo es una estafa' },
    },
    call: {
      connecting: 'Conectando…',
      inCall: 'En llamada',
      hangUp: '🔴 Colgar',
      mom: {
        line: '¿Hola, cariño? Ten cuidado al volver a casa, ¡estoy haciendo tu cena favorita!',
        a: '«¡Mamá, ya estoy de camino!»',
        b: '«¡Te quiero, Mamá! ¡Te ayudo a poner la mesa y a fregar!»',
        ra: 'Vale, hasta ahora. ¡Ve con cuidado!',
        rb: '¡Qué detallista eres! Estoy muy orgullosa.',
      },
      dad: {
        line: '¿Sí? Acabo de salir de una reunión. ¿Qué pasa?',
        a: '«¡Papá, vuelve a tiempo y cena con nosotros!»',
        b: '«No trabajes tanto, Papá. ¡Vuelve pronto!»',
        reply: 'Como me lo pides tan bien, ¡recojo y voy a casa a cenar!',
      },
      friend: {
        line: '¡Ey! Este finde hacemos pícnic y baloncesto. ¿Traes tu famosa merienda?',
        a: '«¡Pues claro! ¡Marchando galletas de arándanos!»',
        b: '«¡Nos vemos en la pista!»',
        reply: '¡Genial! ¡Todos te esperan en el grupo!',
      },
      hotline: {
        line: 'Ha llamado a la línea antifraude 165. Los cobros inesperados o los desconocidos que piden contraseñas son siempre una estafa.',
        a: '«Entendido, estaré atento/a. ¡Gracias, agente!»',
        reply: '¡Muy buena conciencia antifraude! ¡Que tengas un día seguro!',
      },
    },
    feed: {
      brand: 'PixelBook',
      tagline: 'Navega con seguridad',
      post: '📷 Publicar una foto',
      rules: '🛡️ Normas de seguridad',
      report: '🔒 Denunciar y bloquear',
      interact: 'Pinchar',
      reported: '✅ Denunciado y bloqueado',
      like: '👍 Me gusta',
      liked: '❤️ Te gusta',
      comment: '💬 Comentar',
      commented: '¡Has respondido a Rain!',
      reportOk: '¡Bien hecho! Te has protegido a ti y a tus amigos.',
      reportBad: '¡Arriesgado! Pinchar en enlaces sospechosos es como se cae en las estafas.',
      likeOn: '¡Te gusta!',
      likeOff: 'Ya no te gusta',
      posts: {
        scam1: {
          author: 'Desconocido «MagnateGamer»',
          time: 'hace 5 min',
          tag: '⚠️ Solicitud de un desconocido',
          content: '¡Hola! Agrégame y te regalo 5000 puntos de juego. ¡Solo tienes que mandarme por privado una captura de tu inicio de sesión!',
        },
        scam2: {
          author: 'Grupo «MÓVILES GRATIS»',
          time: 'hace 25 min',
          tag: '⚠️ Phishing',
          content: '¡Oferta limitada! ¡Pincha el enlace y escribe el teléfono y el número de tarjeta de tus padres para ganar un móvil gratis!',
        },
        rain: {
          author: 'Rain, tu mejor amiga 📚',
          time: 'hace 1 h',
          tag: '🌿 Vida en el insti',
          content: 'Hoy he repasado vocabulario de inglés en la biblioteca, ¡qué productivo! ¿Alguien se apunta a un pícnic este finde? 🥪',
        },
        mine: {
          author: 'Yo',
          time: 'ahora mismo',
          tag: '🍰 Repostería',
          content: '¡He hecho un bizcocho chiffon de fresa después de clase! A toda la familia le ha encantado~',
        },
      },
      photoTitle: '📷 Nueva publicación',
      photoText: '¿Qué quieres compartir? (¡Piensa en tu privacidad!)',
      photoCake: '🍰 Mi pastel recién hecho',
      photoCakeDone: '¡Publicado! A tus amigos les está gustando.',
      photoDoor: '🏠 La puerta de mi casa con el número',
      warnTitle: '⚠️ ¡Aviso de seguridad!',
      warnText: '¡Nunca publiques fotos en las que se vea el número de tu casa, el portal o tus llaves! Un desconocido podría usarlas para saber dónde vives.',
      warnFix: 'Ocultar el número y publicar una foto del insti',
      warnFixed: '¡Muy bien, has protegido tu dirección!',
      rulesTitle: '🛡️ Normas de seguridad en internet',
      rulesText: '**1. No aceptes a desconocidos.** Los perfiles en internet pueden ser falsos.\n\n**2. Tu información personal es privada.** Tu nombre completo, teléfono, dirección y clase nunca se publican.\n\n**3. Las contraseñas son secretas.** Quien te ofrece cosas gratis a cambio de tu contraseña o código es un estafador.\n\n**4. Si algo te da mala espina, pide ayuda.** Cuéntaselo enseguida a tus padres o a un profe.',
      rulesClaim: '¡Me las sé de memoria! (+5⭐)',
    },
    radio: {
      title: '📻 Radio para aprender',
      text: 'Elige algo para escuchar (se abre YouTube):',
      a: { name: 'mebook888 inglés diario', sub: 'Conversación y comprensión oral' },
      b: { name: 'Lista de pop en inglés', sub: 'Canciones alegres para tararear' },
      c: { name: 'Ciencia para niños en inglés', sub: 'Aprende ciencia e inglés' },
      opened: 'Abierto en una pestaña nueva.',
    },
  },

  english: {
    title: '📚 Shadowing de inglés',
    hint: '🔊 Escucha → 🎤 Repite → ✅ Gana estrellas',
    listen: '🔊 Escuchar',
    practice: '🎤 Practicar',
    sayIt: (w: string) => `Dilo claro y en voz alta: **${w}**`,
    listening: '🎤 Escuchando… di la palabra ahora',
    heard: (s: string) => `He oído: «${s}»`,
    match: '¡Muy buena pronunciación!',
    noMatch: 'Casi… escúchala otra vez y vuelve a intentarlo.',
    selfCheck: '✅ Lo he dicho claro',
    tryMic: '🎤 Comprobar con el micrófono',
    again: '🔁 Escuchar otra vez',
    noMic: 'Micrófono no disponible: usa el botón de autocomprobación.',
    meanings: {
      responsibility: 'responsabilidad',
      empathize: 'entender los sentimientos de los demás',
      discipline: 'autocontrol, disciplina',
      resilient: 'capaz de recuperarse',
      boundary: 'un límite personal',
      procrastinate: 'dejar las cosas para más tarde',
      cyberbullying: 'acoso por internet',
    },
  },

  blocks: {
    title: '🧱 Torre de bloques',
    score: 'Puntos',
    lines: 'Líneas',
    level: 'Nivel',
    next: 'Siguiente',
    restart: 'Reiniciar',
    quit: 'Salir',
    over: 'Fin de la partida',
    cleared: (n: number) => (n === 1 ? '¡1 línea completada!' : `¡${n} líneas completadas!`),
    quad: '💥 ¡Cuatro líneas a la vez!',
    capped: 'Has llegado al límite diario de estrellas de este juego. ¡Juega solo por diversión!',
    final: (score: number) => `Puntuación final: ${score}`,
  },

  puzzle: {
    title: '🧩 Puzle deslizante',
    hint: 'Toca una pieza junto al hueco. ¡Ordena del 1 al 8!',
    shuffle: 'Mezclar',
    moves: (n: number) => `Movimientos: ${n}`,
    solved: '🎉 ¡Puzle resuelto!',
  },

  radio: {
    title: '📻 Radio en inglés',
  },

  party: {
    title: '🎂 Fiestas de cumpleaños',
    text: '¿De quién celebramos el cumpleaños? (¡Cada fiesta necesita un pastel!)',
    me: (d: string) => `🎉 Mi cumpleaños (${d})`,
    mom: (d: string) => `💐 El cumpleaños de Mamá (${d})`,
    dad: (d: string) => `👔 El cumpleaños de Papá (${d})`,
    emma: (d: string) => `👭 El cumpleaños de Emma (${d})`,
    date: (m: number, d: number) => `${d}/${m}`,
    needCake: 'Necesitas un pastel para la fiesta. ¡Hornea uno!',
    done: '¡Este cumpleaños ya lo habéis celebrado!',
    meTitle: '🎂 Mi fiesta de cumpleaños',
    meText: '¡Mamá, Papá, tu hermanita, Emma y Jay están aquí! En la mesa hay un bizcocho chiffon de fresa con las velas encendidas y todos te cantan. 🎶',
    meWish: '🌟 Cierra los ojos y pide un deseo',
    meBlow: '¡Soplas las velas y todos aplauden! Mamá te da un regalo, Papá te revuelve el pelo y tu hermanita coge la primera fresa.',
    meThanks: '¡Gracias a todos! 💖',
    meVoice: '¡Feliz cumpleaños, cariño! ¡Pide un deseo!',
    momTitle: '💐 El cumpleaños de Mamá',
    momText: 'Has hecho a escondidas un bizcocho chiffon de fresa y has encendido las velas. Todos cantan y le dais a Mamá una tarjeta escrita a mano: «¡Gracias por cuidarnos siempre!»',
    momAct: 'Darle a Mamá el primer trozo',
    momVoice: '¡Gracias, cariño! ¡Es el mejor regalo del mundo!',
    momDone: 'A Mamá se le saltan las lágrimas y te da un abrazo muy largo.',
    dadTitle: '👔 El cumpleaños de Papá',
    dadText: '¡Papá ha llegado a tiempo! La mesa está llena de comida casera, todos llevan gorritos de fiesta y ahí está tu pastel casero.',
    dadAct: '«¡Feliz cumpleaños, Papá! ¡Gracias por esforzarte tanto!»',
    dadVoice: '¡Jaja! ¡Gracias! ¡Todos los días de trabajo valen la pena por esto!',
    dadDone: 'Papá se ríe a carcajadas. ¡La familia nunca había estado tan unida!',
    emmaTitle: '👭 El pícnic de cumpleaños de Emma',
    emmaText: '¡Sol sobre la hierba, una manta, dulces caseros y todos celebrando el cumple de Emma!',
    emmaAct: 'Darle el pastel y una tarjeta',
    emmaVoice: '¡Muchísimas gracias! ¡Eres lo mejor del mundo!',
    emmaDone: '¡Emma está loca de contenta!',
  },

  map: {
    names: { town: 'Ciudad', school: 'Insti', home: 'Casa', store: 'Tienda de la esquina' },
    you: 'Tú',
    goal: 'Objetivo',
    people: 'Gente',
    doors: 'Puertas',
  },

  quests: {
    title: 'Misiones',
    started: 'Nueva misión',
    completed: 'Misión cumplida',
    active: 'En curso',
    available: 'Disponible',
    done: 'Hechas',
    track: 'Seguir',
    tracking: 'Siguiendo',
    none: 'Aún no tienes misiones. ¡Habla con la gente que te encuentres!',
    clover: (n: number, total: number) => `🍀 Trébol de la suerte ${n}/${total}`,
    lapsDone: (secs: number) => `🏁 ¡Todas las banderas en ${secs} s! Díselo al entrenador.`,
    lapsFail: '⏱ ¡Se acabó el tiempo! Habla con el entrenador Hsu para volver a intentarlo.',
    list: {
      atlas: {
        title: 'El atlas perdido',
        desc: 'El gran atlas del mundo de la señora Wang ha desaparecido de la biblioteca.',
        steps: ['Hablar con la señora Wang en la biblioteca', 'Buscar el atlas en el aula de 2.º C', 'Devolverle el atlas a la señora Wang'],
      },
      riceBall: {
        title: 'Un conserje con hambre',
        desc: 'El tío Chun se ha saltado el desayuno por vigilar la puerta.',
        steps: ['Hablar con el tío Chun en la puerta del insti', 'Comprar una bola de arroz en la tienda de la esquina', 'Llevarle la bola de arroz al tío Chun'],
      },
      laps: {
        title: 'Contra el reloj',
        desc: 'El entrenador Hsu te reta a pasar por todas las banderas de la pista en menos de un minuto.',
        steps: ['Hablar con el entrenador Hsu en el campo de deportes', 'Pasar por las 4 banderas en orden', 'Decirle al entrenador Hsu que lo has conseguido'],
      },
      study: {
        title: 'Compañeros de estudio',
        desc: 'Rain quiere practicar vocabulario de inglés contigo.',
        steps: ['Hablar con Rain en la biblioteca', 'Practicar 3 palabras distintas (shadowing)', 'Contarle a Rain qué tal ha ido'],
      },
      kitten: {
        title: '¿Dónde está Mochi?',
        desc: 'La gatita de la abuela Lee se ha escapado por el parque.',
        steps: ['Hablar con la abuela Lee en el parque', 'Buscar en los arbustos del parque: atento/a a si se mueven las hojas', 'Llevarle a Mochi a la abuela Lee'],
      },
      kite: {
        title: 'Una cometa en el árbol',
        desc: 'La cometa de Bo se ha quedado enganchada en el árbol grande del barrio.',
        steps: ['Hablar con Bo en el barrio', 'Sacudir el árbol grande (¡tres veces!)', 'Devolverle la cometa a Bo'],
      },
      xiaoyuPicnic: {
        title: 'Un sitio en el pícnic',
        desc: 'El sábado, Xiaoyu está solo en el parque.',
        steps: ['Hablar con Xiaoyu en el parque', 'Preguntar a Emma si Xiaoyu puede venir al pícnic', 'Preguntar a Emma si Xiaoyu puede venir al pícnic'],
      },
      letter: {
        title: 'Entrega especial',
        desc: 'Mamá tiene una carta para la abuela Lee.',
        steps: ['Preguntar a Mamá si necesita ayuda', 'Darle la carta a la abuela Lee en el parque', 'Darle la carta a la abuela Lee en el parque'],
      },
      clovers: {
        title: 'Tréboles de la suerte',
        desc: 'Hay tréboles de cuatro hojas escondidos por la ciudad, en el insti y en casa.',
        steps: ['Estate atento/a a los tréboles que brillan', 'Encontrar todos los tréboles de la suerte', 'Encontrar todos los tréboles de la suerte'],
      },
      postcards: {
        title: 'Postales para la abuela',
        desc: 'La abuela Lee nunca vio la gran ciudad. Tráele postales de tres lugares de Taipéi.',
        steps: ['Hablar con la abuela Lee en el parque', 'Conseguir postales en la Estación Central, el templo de Longshan y la Plaza de la Libertad', 'Darle las postales a la abuela Lee'],
      },
      pineapple: {
        title: 'Pasteles de piña de Taipéi',
        desc: 'Mamá quiere una caja de pasteles de piña de Taipéi de verdad para la merienda con la abuela.',
        steps: ['Hablar con mamá en casa', 'Comprar pasteles de piña al dependiente de Taipéi', 'Darle los pasteles de piña a mamá'],
      },
      elephant: {
        title: 'La foto desde la Montaña del Elefante',
        desc: 'Emma quiere una foto del Taipéi 101 hecha desde lo alto de la Montaña del Elefante.',
        steps: ['Hablar con Emma en casa', 'Pedirle una foto al senderista del mirador de la Montaña del Elefante', 'Enseñarle la foto a Emma'],
      },
      mochi: {
        title: 'Mochi de Hualien',
        desc: 'Bo cambia su mejor canica por una caja de mochi blandito de Hualien.',
        steps: ['Hablar con Bo en el barrio', 'Comprar mochi a la señora del mochi en Hualien', 'Darle el mochi a Bo'],
      },
      pebble: {
        title: 'Un guijarro de Qixingtan',
        desc: 'A la colección de piedras de Rain le falta un guijarro de la playa de Qixingtan.',
        steps: ['Hablar con Rain en la biblioteca', 'Pedirle un guijarro al pescador de la playa de Qixingtan', 'Darle el guijarro a Rain'],
      },
    },
  },

  library: {
    hello: 'Chis… bienvenido/a a la biblioteca. Tómate tu tiempo.',
    ask: 'Ay, madre. Nuestro gran atlas del mundo ha desaparecido: creo que un alumno lo cogió para Geografía y se lo dejó en un aula. ¿Podrías buscarlo?',
    accept: '¡Claro, yo lo encuentro!',
    hint: 'Los de 2.º C han tenido Geografía esta mañana. ¡Mira en sus pupitres!',
    thanks: '¡Lo has encontrado! Gracias. Toma, un detallito para el mejor ayudante de la biblioteca.',
    found: 'Debajo del pupitre, medio escondido detrás de una mochila… ¡el atlas del mundo!',
    deskNothing: 'Un pupitre con garabatos grabados en una esquina.',
    shelfText: 'Enciclopedias, cómics, poesía… las estanterías huelen a papel viejo.',
    read: 'Leer un rato (+10 de estudio)',
    readToast: 'Aprendes algo nuevo sobre los pulpos. ¡Tienen tres corazones!',
  },

  vending: { text: 'Bebidas de colores tras el cristal. Zumba bajito.', buy: 'Comprar un zumo', bought: '¡Clonc! Cae un zumo en brik.' },
  canteen: {
    text: 'Menú de hoy: arroz, tofu guisado, verduras y sopa.',
    closed: 'La barra del comedor abre de 11:30 a 13:30.',
    lunch: 'Comer (+30 de energía)',
    lunchDone: 'Calentito y contundente. ¡Ya estás listo/a para la tarde!',
  },
  busStop: {
    text: 'Línea 8: a la estación de tren. El próximo autobús pasa en 12 minutos.',
    where: 'Aquí para la línea 8. ¿Adónde quieres ir? (Pregunta en inglés: “Does this bus go to the mall?”)',
    stops: { busStopW: 'Oeste — tienda, parque y casa', busStop: 'Colegio', busStopE: 'Este — polideportivo y centro comercial' },
    here: '📍 Estás aquí',
    notNow: 'Ahora no',
    beep: '🚌 ¡Pip! Pasas la tarjeta EasyCard y subes.',
    arrived: (name: string) => `🚏 ${name}. “Thank you, driver!”`,
    night: 'Ya ha pasado el último autobús (circulan de 6:00 a 22:00). ¡Toca caminar!',
  },
  mailbox: {
    postcard: '¡Una postal del abuelo! «Hoy he visto el mar. Pórtate bien, estudia mucho y cómete la verdura».',
    empty: 'El buzón está vacío.',
  },
  pond: { text: 'Peces naranjas se deslizan bajo los nenúfares.', feed: 'Dar de comer a los peces (+ánimo)', feedToast: '¡Los peces se arremolinan en un torbellino naranja!' },
  bush: { text: 'Un arbusto espeso y frondoso.' },
  kitten: {
    found: 'Hay algo blanco acurrucado entre las hojas… ¡es Mochi! La gatita maúlla y te sigue.',
    notHere: 'Apartas las hojas… nada, solo un escarabajo asustado.',
  },
  kite: {
    hello: '¡Mi cometa es la que vuela más alto de toda la calle!',
    ask: '¡Mi cometa se ha quedado enganchada en el árbol grande! Soy demasiado bajito para llegar… ¿me ayudas?',
    accept: '¡Déjamelo a mí!',
    waiting: '¡Sacude el árbol con fuerza! Es el grande que hay junto al camino.',
    thanks: '¡Mi cometa! ¡Eres lo más! ¡Toma, unos caramelos!',
    after: '¡Mira qué alto vuela!',
    treeText: 'Un árbol grande y viejo con un tronco muy gordo.',
    treeAfter: 'Las ramas se mecen suavemente. Ya no quedan cometas ahí arriba.',
    shakeMore: (n: number) => `Las ramas se sacuden… ¡la cometa se tambalea! (${n === 1 ? 'una vez más' : `${n} veces más`})`,
    fell: '¡Con una última sacudida, la cometa cae revoloteando en tus manos!',
  },
  swing: { text: 'Un columpio con las cadenas calentitas por el sol.', play: 'Columpiarte un rato', toast: '¡Yujuuu! ¡Más alto, más alto!' },
  fridge: { text: 'Sobras, fruta y un flan con tu nombre.', snack: 'Picar algo (+12 de energía)', snackToast: '¡Mmm! El flan de Mamá es el mejor.' },
  tv: { text: 'Están echando un programa de cocina.', watch: 'Mirarlo un rato', toast: 'Aprendes a cerrar empanadillas chinas. Más o menos.' },
  rain: {
    hello: '¡Ey! La biblioteca es mi sitio favorito.',
    offer: '¿Quieres que seamos compañeros de estudio? ¡Practica tres palabras en inglés y luego me cuentas qué tal!',
    accept: '¡Hecho!',
    waiting: (n: number) => `¿Qué tal va? Hoy has practicado ${n}/3 palabras.`,
    done: '¡Increíble! ¡Tu pronunciación está mejorando un montón!',
    sat: '¡Sábado en el parque! ¿Has visto los peces del estanque?',
  },
  coach: {
    hello: '¡Esas rodillas arriba, chicos!',
    offer: '¡Pareces rápido/a! Pasa por las cuatro banderas de la pista, en orden, en menos de un minuto. ¿Preparado/a?',
    retry: '¿Otro intento? ¡Cuatro banderas, un minuto!',
    accept: '¡Preparado/a!',
    go: '🏁 ¡Ya! ¡Sigue las banderas!',
    running: '¡Vamos, vamos, vamos! ¡Sigue las banderas!',
    done: '¡Gran carrera! ¡Así se hace!',
    after: 'Buen trabajo hoy. ¡Acuérdate de estirar!',
  },
  clerk: {
    lines: ['¡Bienvenido/a! Acaban de llegar bolas de arroz recién hechas.', '¡Hola otra vez! ¿Necesitas algo?', 'Las fresas están de temporada: ¡dulcísimas!'],
    shop: '🛒 Vamos a comprar',
  },
  grandma: {
    lines: ['Las palomas ya me conocen. ¡Cu, cu!', 'Qué día tan bonito para pasear.', 'Me recuerdas a mi nieto.'],
    kittenAsk: 'Ay, cielo… mi gatita Mochi se ha salido de la cesta y se ha metido entre los arbustos. Mis rodillas ya no son lo que eran…',
    kittenAccept: '¡Yo encontraré a Mochi!',
    kittenWaiting: 'Escucha con atención: si un arbusto se mueve, puede que Mochi esté dentro.',
    kittenThanks: '¡Mochi! ¡Ay, gracias, gracias! Toma, esto por las molestias.',
    letterThanks: '¿Una carta de tu madre? Qué detalle. ¡Dile que la semana que viene le llevo empanadillas!',
  },
  cat: { lines: ['Miau~ 🐱', 'Rrrrr…', 'El gato se restriega contra tu pierna.', 'El gato te mira parpadeando despacio. Eso significa «me caes bien».'] },

  talks: esTalks,
  ...esExtra,
  ...esPlaces,
  ...esArcade,
  ...esTreasure,
  ...esTalks3,
  ...esGuide,
  ...esWorld3,
  ...esTrips,
  ...esSky,
  ...esFamily,
  ...esClassroom,
  ...esLife,
  ...esXinyi,
  ...esXimen,
  ...esCks,
  ...esHlcity,
  ...esTaroko,
  ...esStory,
  ...esAirport,
  ...esKaohsiung,
  ...esTainan,
  ...esBarcelona,

  rewards: {
    stars: (n: number) => `+${n}⭐`,
    energy: (n: number) => `+${n}⚡`,
    mood: (n: number) => `+${n}💚`,
    study: (n: number) => `+${n}📄`,
    coins: (n: number) => `+${n}🪙`,
    love: (n: number) => `+${n}💖`,
    got: (what: string) => `Has conseguido: ${what}`,
  },
};
